<template>
    <div id="app">
        <div v-if="isServerAvailable">
            <router-view/>
        </div>
        <div v-else>
            <DeadServer/>
        </div>
        <GoTop :z-index="9000" :right="25" :bg-color="'#b89453'"/>
    </div>
</template>

<script>
import BackendService from "./core/backend/backend.service";
import DeadServer from "./components/common/DeadServer";
import GoTop from '@inotom/vue-go-top';
import {EVENT_LANG_CHANGE, EVENT_LANG_CHANGE_SIDEBAR} from "@/core/constants";

export default {
    components: {DeadServer, GoTop},
    data() {
        return {
            version: 'n/a'
        }
    },
    created() {
        BackendService.checkServerReadiness()
            .then(response => {
                this.$set(this, 'version', response.data.version);
                this.$store.dispatch('configStore/updateConfiguration', response.data.config);
            })
            .catch(() => {
                this.$set(this, 'version', false);
            });

        this.$eventBus.$on(EVENT_LANG_CHANGE_SIDEBAR, () => {
            this.$store.dispatch('explorerStore/removeLangSensitives');
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    computed: {
        serverVersion() {
            return this.version;
        },

        isServerAvailable() {
            return this.version !== false;
        }
    }
}
</script>

<style scoped>

</style>
